export const RETRIEVE_ORDERS = 'commercial/orders/retrieve';

export const RETRIEVE_ORDER = 'commercial/orders/getById';
